import React, { useState, useRef, useEffect } from "react";
import DashboardTopSearch from "../../../components/DashboardTopSearch/DashboardTopSearch";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import Reviews from "../../../components/Reviews/Reviews";
import img1 from "../../../assets/images/course-img.jpg";
import WhatYouLearnInThisCourse from "../../../components/WhatYouLearnInThisCourse/WhatYouLearnInThisCourse";
import createrImg from "../../../assets/images/user.png";
import CourseDetailsInstructorInfo from "../../../components/CourseDetailsInstructorInfo/CourseDetailsInstructorInfo";
import CourseDetailChapterList from "../../../components/CourseDetailChapterList/CourseDetailChapterList";
import ProgressBar from "../../../components/ProgressBar/ProgressBar";
import { useDispatch, useSelector } from "react-redux";
import { Image, Modal, Button } from "react-bootstrap";
import Slider from "react-slick";
import { getCourseByIdForStudentCourse } from "../../../redux/features/courseSlice";
import { studentEnrolledCourse } from "../../../redux/features/courseSlice";
import { createStudentFavoriteCourseApi } from "../../../redux/features/studentDetailSlice";
import { studentUnenrolledCourse } from "../../../redux/features/courseSlice";
import { removeStudentFavoriteCourseApi } from "../../../redux/features/studentDetailSlice";
import toast from "react-hot-toast";
import Notification from "../../../components/Notification/Notification";
import DottedLoading from "../../../components/DottedLoading/DottedLoading";
import TruncateText from "../../../components/truncateText/TruncateText";
import InstructorNotification from "../../../components/Notification/InstructorNotification";
import AdminNotification from "../../../components/Notification/AdminNotification";

// Confirmation Modal Component
const ConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  actionType,
  courseTitle,
  isConfirmLoading, // New prop to handle loading state
}) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <strong>
            Confirm {actionType === "enroll" ? "Enrollment" : "Unenrollment"}
          </strong>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to{" "}
        {actionType === "enroll" ? "enroll in" : "unenroll from"} the course "
        {courseTitle}"?
        {actionType === "unenroll" &&
          " This action will remove your progress and access to the course."}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={onHide}
          disabled={isConfirmLoading}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={onConfirm}
          disabled={isConfirmLoading}
        >
          {isConfirmLoading ? <DottedLoading /> : "Confirm"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

// New Congratulations Modal Component
const CongratulationsModal = ({ show, onHide, message }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <strong>Welcome</strong>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center ah-text-md">
        {message || "You have successfully enrolled in the course!"}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const StudentCourseDetail = () => {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const [activeSlide, setActiveSlide] = useState(0);
  const [imagesSliderList, setImagesSliderList] = useState([]);
  const [getCourseDetail, setGetCourseDetail] = useState({});
  // const [getCourseReview, setGetCourseReview] = useState({});
  const [getCourseUnit, setGetCourseUnit] = useState([]);
  const [progressCourse, setProgressCourse] = useState(null);
  const [reviewAverage, setReviewAverage] = useState(null);
  const [enrolled, setEnrolled] = useState(false);
  const [courseFavorite, setCourseFavorite] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmActionType, setConfirmActionType] = useState("");
  const [showCongratsModal, setShowCongratsModal] = useState(false);
  const [congratsMessage, setCongratsMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState(false); // New state for confirm button loading

  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const auth = useSelector((state) => state.auth);

  let sliderRef1 = useRef(null);
  let sliderRef2 = useRef(null);

  const navOneSlider = {
  dots: true,
  infinite: false,
  arrows: false,
  beforeChange: (oldIndex, newIndex) => setActiveSlide(newIndex),
};

const navTwoSlider = {
  infinite: false,
  arrows: false,
  slidesToShow: 4,
  swipeToSlide: true,
  focusOnSelect: true,
};

  const getCoursesFetchCall = async () => {
    setIsLoading(true);
    try {
      const res = await dispatch(
        getCourseByIdForStudentCourse({
          token: auth.token,
          courseId: searchParams.get("id"),
        })
      ).unwrap();
      console.log("data", res)
      if (res.success) {
        setGetCourseDetail(res?.data?.course);
        // setGetCourseReview(res?.data?.reviews);
        setGetCourseUnit(res?.data?.course);
        setEnrolled(res?.data?.enrollment);
        setCourseFavorite(res?.data?.favorites);
        setProgressCourse(res?.data?.progress);
        setReviewAverage(res?.data?.reviewAverage);
        let images = [];
        if (res.data?.course?.image_urls) {
          try {
            images = JSON.parse(res?.data?.course?.image_urls);
            if (!Array.isArray(images)) {
              images = [images];
            }
          } catch (error) {
            console.error("Error parsing image_urls:", error);
            images = [img1];
          }
        } else {
          images = [img1];
        }
        setImagesSliderList(images);
      }
    } catch (error) {
      console.error("Error fetching course:", error);
      toast.error("Failed to fetch course details.", {
        position: "top-center",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setNav1(sliderRef1);
    setNav2(sliderRef2);
    getCoursesFetchCall();
  }, [dispatch, auth.token, searchParams]);

  const handleFullscreen = () => {
    const allImages = document.querySelectorAll("#mainImage");
    const currentImage = allImages[activeSlide];
    if (currentImage) {
      if (currentImage.requestFullscreen) {
        currentImage.requestFullscreen();
      } else if (currentImage.webkitRequestFullscreen) {
        currentImage.webkitRequestFullscreen();
      } else if (currentImage.msRequestFullscreen) {
        currentImage.msRequestFullscreen();
      }
    }
  };

  const courseEnrolled = async () => {
    setIsConfirmLoading(true); // Set loading state
    try {
      const res = await dispatch(
        studentEnrolledCourse({
          token: auth.token,
          courseId: searchParams.get("id"),
        })
      ).unwrap();
      if (res.success) {
        setCongratsMessage(
          res?.message || "You have successfully enrolled in the course!"
        );
        setShowCongratsModal(true);
        setEnrolled(true);
      }
    } catch (error) {
      const errorMessage = error?.message || "Failed to enroll in the course.";
      toast.error(errorMessage, { position: "top-center" });
    } finally {
      setIsConfirmLoading(false); // Reset loading state
    }
  };

  const courseUnenrolled = async () => {
    setIsConfirmLoading(true); // Set loading state
    try {
      const res = await dispatch(
        studentUnenrolledCourse({
          token: auth.token,
          courseId: searchParams.get("id"),
        })
      ).unwrap();
      if (res.success) {
        toast.success(res?.message, { position: "top-center" });
        setEnrolled(false);
      }
    } catch (error) {
      const errorMessage =
        error?.message || "Failed to unenroll from the course.";
      toast.error(errorMessage, { position: "top-center" });
    } finally {
      setIsConfirmLoading(false); // Reset loading state
    }
  };

  const favouritesCourseHandler = async () => {
    try {
      const res = await dispatch(
        createStudentFavoriteCourseApi({
          token: auth.token,
          courseId: searchParams.get("id"),
        })
      ).unwrap();
      if (res.success) {
        toast.success(res?.message, { position: "top-center" });
        setCourseFavorite(true);
      }
    } catch (error) {
      const errorMessage = error?.message || "Failed to favorite the course.";
      toast.error(errorMessage, { position: "top-center" });
    }
  };

  const unfavoriteCourseHandler = async () => {
    try {
      const res = await dispatch(
        removeStudentFavoriteCourseApi({
          token: auth.token,
          courseId: searchParams.get("id"),
        })
      ).unwrap();
      if (res.success) {
        toast.success(res?.message, { position: "top-center" });
        setCourseFavorite(false);
      }
    } catch (error) {
      const errorMessage = error?.message || "Failed to unfavorite the course.";
      toast.error(errorMessage, { position: "top-center" });
    }
  };

  const confirmEnroll = () => {
    setConfirmActionType("enroll");
    setShowConfirmModal(true);
  };

  const confirmUnenroll = () => {
    setConfirmActionType("unenroll");
    setShowConfirmModal(true);
  };

  const handleConfirmAction = async () => {
    if (confirmActionType === "enroll") {
      await courseEnrolled();
    } else if (confirmActionType === "unenroll") {
      await courseUnenrolled();
    }
    setShowConfirmModal(false);
    setConfirmActionType("");
  };

  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };

  return (
    <>
      {isLoading ? (
        <div className="loader-container">
          <span className="dottedLoading theme-color"></span>
        </div>
      ) : (
        <>
          <div className="topbar mb-20 mb-lg-36">
            <div className="d-flex align-items-center justify-content-between">
              <h3
                className="ah-heading-04 fw-bold black-800 me-29 mb-0 d-flex align-items-center gap-3 cursor-pointer"
                onClick={goBack}
              >
                <span className="icon-arrow-left"></span>Course Details
              </h3>
              <div className="search-wrapper d-none d-lg-flex align-items-center gap-3">
                <DashboardTopSearch />
                {auth.role.toLowerCase() === "student" ? <Notification /> : auth.role.toLowerCase() === "instructor" ? <InstructorNotification /> : auth.role.toLowerCase() === "admin" ? <AdminNotification /> : null}
              </div>
            </div>
          </div>
          <div className="course-detail-content">
            <div className="row mb-20 mb-sm-30 mb-md-40">
              <div className="col-12 col-xl-5 mb-10 slider-align">
                <div className="mainImageContainer mb-27">
                  <div className="slider-for-course-img">
                    <Slider {...navOneSlider} asNavFor={nav2} ref={setNav1}>
                      {imagesSliderList.map((image, index) => (
                        <div key={index}>
                          <Image
                            id="mainImage"
                            src={
                              image.startsWith("/")
                                ? `${process.env.REACT_APP_GALLERY_URL}${image}`
                                : image
                            }
                            alt={`Course image ${index + 1}`}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = img1;
                            }}
                          />
                        </div>
                      ))}
                    </Slider>
                  </div>
                  <button className="fullscreen-btn" onClick={handleFullscreen}>
                    <svg
                      width="19"
                      height="19"
                      viewBox="0 0 19 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18.2053 1.549C18.2053 1.25009 18.0866 0.963425 17.8752 0.752066C17.6639 0.540707 17.3772 0.421967 17.0783 0.421967H11.4431C11.1442 0.421967 10.8576 0.540707 10.6462 0.752066C10.4349 0.963425 10.3161 1.25009 10.3161 1.549C10.3161 1.8479 10.4349 2.13457 10.6462 2.34593C10.8576 2.55729 11.1442 2.67603 11.4431 2.67603H14.3396L10.643 6.38395C10.5373 6.48873 10.4535 6.61338 10.3963 6.75072C10.339 6.88805 10.3096 7.03536 10.3096 7.18414C10.3096 7.33293 10.339 7.48024 10.3963 7.61757C10.4535 7.75491 10.5373 7.87956 10.643 7.98434C10.7477 8.08997 10.8724 8.17381 11.0097 8.23103C11.1471 8.28825 11.2944 8.31771 11.4431 8.31771C11.5919 8.31771 11.7392 8.28825 11.8766 8.23103C12.0139 8.17381 12.1386 8.08997 12.2433 7.98434L15.9513 4.27641V7.18414C15.9513 7.48305 16.07 7.76972 16.2814 7.98107C16.4927 8.19243 16.7794 8.31117 17.0783 8.31117C17.3772 8.31117 17.6639 8.19243 17.8752 7.98107C18.0866 7.76972 18.2053 7.48305 18.2053 7.18414V1.549ZM7.73522 10.8921C7.63045 10.7864 7.5058 10.7026 7.36846 10.6454C7.23112 10.5882 7.08381 10.5587 6.93503 10.5587C6.78625 10.5587 6.63894 10.5882 6.5016 10.6454C6.36426 10.7026 6.23961 10.7864 6.13484 10.8921L2.42691 14.5887V11.6923C2.42691 11.3934 2.30817 11.1067 2.09681 10.8953C1.88545 10.684 1.59879 10.5652 1.29988 10.5652C1.00097 10.5652 0.71431 10.684 0.502951 10.8953C0.291592 11.1067 0.172852 11.3934 0.172852 11.6923V17.3274C0.172852 17.6263 0.291592 17.913 0.502951 18.1243C0.71431 18.3357 1.00097 18.4544 1.29988 18.4544H6.93503C7.23394 18.4544 7.5206 18.3357 7.73196 18.1243C7.94332 17.913 8.06206 17.6263 8.06206 17.3274C8.06206 17.0285 7.94332 16.7418 7.73196 16.5305C7.5206 16.3191 7.23394 16.2004 6.93503 16.2004H4.02729L7.73522 12.4925C7.84086 12.3877 7.9247 12.263 7.98192 12.1257C8.03914 11.9884 8.06859 11.841 8.06859 11.6923C8.06859 11.5435 8.03914 11.3962 7.98192 11.2588C7.9247 11.1215 7.84086 10.9968 7.73522 10.8921Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                </div>
                <div className="slick-slider-thumbs">
                  <Slider {...navTwoSlider} asNavFor={nav1} ref={setNav2}>
                    {imagesSliderList.map((image, index) => (
                      <div key={index}>
                        <Image
                          src={
                            image.startsWith("/")
                              ? `${process.env.REACT_APP_GALLERY_URL}${image}`
                              : image
                          }
                          alt={`Thumbnail ${index + 1}`}
                          className="thumb"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = img1;
                          }}
                        />
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
              <div className="col-12 col-xl-7 mb-10 content-align flex-grow-1">
                <div className="d-flex align-items-center justify-content-between mb-28">
                  <div>
                    <span className="ah-text-lg fw-bold text-green mb-12 text-uppercase d-block">
                      {getCourseDetail?.Category?.name}
                    </span>
                    <h2 className="ad-heading-01 fw-bold mb-0">
                      {getCourseDetail?.title}
                    </h2>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    {courseFavorite ? (
                      <span
                        onClick={() => unfavoriteCourseHandler()}
                        className="btn btn-soft-green share-btn text-lg fw-semibold no-shadow py-10 px-13 min-vw-auto"
                        style={{ background: "#82BD00" }}
                      >
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M16.696 3.62732C14.652 3.62732 12.887 4.82432 12 6.57032C11.113 4.82432 9.348 3.62732 7.304 3.62732C4.374 3.62732 2 6.08432 2 9.10832C2 12.1323 3.817 14.9043 6.165 17.1813C8.513 19.4583 12 21.6273 12 21.6273C12 21.6273 15.374 19.4943 17.835 17.1813C20.46 14.7153 22 12.1413 22 9.10832C22 6.07532 19.626 3.62732 16.696 3.62732Z"
                            fill="#F0F7E0"
                          />
                          <path
                            d="M16.696 3.62732C14.652 3.62732 12.887 4.82432 12 6.57032C11.113 4.82432 9.348 3.62732 7.304 3.62732C4.374 3.62732 2 6.08432 2 9.10832C2 12.1323 3.817 14.9043 6.165 17.1813C8.513 19.4583 12 21.6273 12 21.6273C12 21.6273 15.374 19.4943 17.835 17.1813C20.46 14.7153 22 12.1413 22 9.10832C22 6.07532 19.626 3.62732 16.696 3.62732Z"
                            stroke="#FFF"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    ) : (
                      <span
                        className="btn btn-soft-green share-btn text-lg fw-semibold no-shadow py-10 px-13 min-vw-auto"
                        onClick={() => favouritesCourseHandler()}
                      >
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M16.696 3.62732C14.652 3.62732 12.887 4.82432 12 6.57032C11.113 4.82432 9.348 3.62732 7.304 3.62732C4.374 3.62732 2 6.08432 2 9.10832C2 12.1323 3.817 14.9043 6.165 17.1813C8.513 19.4583 12 21.6273 12 21.6273C12 21.6273 15.374 19.4943 17.835 17.1813C20.46 14.7153 22 12.1413 22 9.10832C22 6.07532 19.626 3.62732 16.696 3.62732Z"
                            fill="#F0F7E0"
                          />
                          <path
                            d="M16.696 3.62732C14.652 3.62732 12.887 4.82432 12 6.57032C11.113 4.82432 9.348 3.62732 7.304 3.62732C4.374 3.62732 2 6.08432 2 9.10832C2 12.1323 3.817 14.9043 6.165 17.1813C8.513 19.4583 12 21.6273 12 21.6273C12 21.6273 15.374 19.4943 17.835 17.1813C20.46 14.7153 22 12.1413 22 9.10832C22 6.07532 19.626 3.62732 16.696 3.62732Z"
                            stroke="#82BD00"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    )}
                  </div>
                </div>
                <TruncateText
                  text={getCourseDetail?.description}
                  limit={1000}
                  className="text-gray-01 ah-text-base mb-26"
                />
                <div className="d-flex gap-3 flex-wrap flex-lg-nowrap flex-xxl-nowrap">
                  {enrolled ? (
                    <>
                      <Link
                        to={`/ai-course-creation-flow?id=${searchParams.get(
                          "id"
                        )}`}
                        className="btn btn-primary ah-text-md fw-semibold no-shadow py-18"
                      >
                        Resume
                      </Link>
                      {progressCourse === 100 ? null : (
                        <button
                          type="button"
                          onClick={confirmUnenroll}
                          className="btn btn-soft-green text-green ah-text-md fw-semibold no-shadow py-18"
                        >
                          Unenrolled
                        </button>
                      )}
                    </>
                  ) : (
                    <button
                      type="button"
                      className={`btn ah-text-md fw-semibold no-shadow py-18 btn-primary`} 
                      style={{cursor: auth.role === "Admin" ? "not-allowed" : "pointer"}}
                      onClick={auth.role === "Admin" ? undefined : confirmEnroll}
                      title={auth.role === "Admin" ? "Admins cannot enroll in courses" : ""}
                    >
                      Get Started
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          <hr className="my-10 my-sm-20 my-md-30 my-lg-42" />
          <div className="card-default-style">
            <h2 className="ad-heading-05 fw-bold mb-10 mb-sm-20 mb-md-32">
              Source
            </h2>
            <div className="course-chapters">
              <CourseDetailChapterList chapters={getCourseUnit} />
            </div>
          </div>
          <hr className="my-10 my-sm-20 my-md-30 my-lg-42" />
          <div>
            <CourseDetailsInstructorInfo
              instructorInfo={getCourseDetail?.instructor}
            />
          </div>
          {/* Existing Confirmation Modal */}
          {showConfirmModal && (
            <ConfirmationModal
              show={showConfirmModal}
              onHide={() => {
                setShowConfirmModal(false);
                setConfirmActionType("");
              }}
              onConfirm={handleConfirmAction}
              actionType={confirmActionType}
              courseTitle={getCourseDetail?.title || "this course"}
              isConfirmLoading={isConfirmLoading} // Pass loading state to modal
            />
          )}
          {/* New Congratulations Modal */}
          {showCongratsModal && (
            <CongratulationsModal
              show={showCongratsModal}
              onHide={() => setShowCongratsModal(false)}
              message={getCourseDetail?.welcome_message}
            />
          )}
        </>
      )}
    </>
  );
};

export default StudentCourseDetail;
